import { flow, types, getEnv } from 'mobx-state-tree'

import { Team } from './'

const Teams = types
  .model('TeamsModel', {
    items: types.optional(types.map(Team), {}),
  })
  .actions((self) => {
    const {
      services: { teamService },
    } = getEnv(self)

    return {
      loadOne: flow(function* (id) {
        if (!self.items.has(id)) {
          const team = yield teamService.get(id)
          self.items.set(id, team)
        }

        return self.items.get(id)
      }),

      load: flow(function* (params) {
        const response = yield teamService.query(params)

        const teams = response.content.map((team) => {
          self.items.set(team.id, team)
          return self.items.get(team.id)
        })

        return {
          response,
          teams,
        }
      }),
    }
  })

export const TeamsRoot = types.model('TeamsRoot', {
  teams: types.optional(Teams, {}),
})
